// 获取七牛云token
export function getToken() {
  return getFetchData({
    url: '/householder/getUpToken',
    method: 'POST'
  })
}

// 七牛上传图片
export const uploadIMG = (data: FormData) => {
  return getFetchData({
    url: 'https://up-as0.qiniup.com',
    method: 'POST',
    data,
    isFormData: true
  })
}
